import { useEffect, useReducer, useCallback } from 'react';

const ACTIONS = {
  SET_ENTITY_TYPE: 'SET_ENTITY_TYPE',
  SEARCH_CHANGE: 'SEARCH_CHANGE',
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE'
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_ENTITY_TYPE:
      return {
        ...state,
        resultsBySearch: {}
      };
    case ACTIONS.SEARCH_CHANGE:
      return {
        ...state,
        searchExpression: action.payload
      };
    case ACTIONS.FETCH_INIT:
      return {
        ...state,
        resultsBySearch: {
          ...state.resultsBySearch,
          [action.payload.searchExpression]: {
            ...state.resultsBySearch[action.payload.searchExpression],
            isLoading: true,
            error: null,
            onTryAgain: null
          }
        }
      };
    case ACTIONS.FETCH_SUCCESS:
      return {
        ...state,
        resultsBySearch: {
          ...state.resultsBySearch,
          [action.payload.searchExpression]: {
            ...state.resultsBySearch[action.payload.searchExpression],
            isLoading: false,
            error: null,
            onTryAgain: null,
            entities: (
              (state.resultsBySearch[action.payload.searchExpression] &&
                state.resultsBySearch[action.payload.searchExpression].entities) ||
              []
            ).concat(action.payload.entities),
            onLoadMore: action.payload.onLoadMore
          }
        }
      };
    case ACTIONS.FETCH_FAILURE:
      return {
        ...state,
        resultsBySearch: {
          ...state.resultsBySearch,
          [action.payload.searchExpression]: {
            ...state.resultsBySearch[action.payload.searchExpression],
            isLoading: false,
            error: action.payload.error,
            onTryAgain: action.payload.onTryAgain
          }
        }
      };
    default:
      throw new Error();
  }
};

export default ({ plugin, entityType, pageLimit = 5, delay = 500 }) => {
  const [state, dispatch] = useReducer(dataReducer, { searchExpression: '', resultsBySearch: {}});
  const { searchExpression, resultsBySearch } = state;
  const { entities = [], isLoading = true, error, onTryAgain, onLoadMore } =
    resultsBySearch[searchExpression] || {};

  useEffect(() => {
    dispatch({ type: ACTIONS.SET_ENTITY_TYPE });
  }, [entityType]);

  useEffect(() => {
    let handler;
    if (plugin && !resultsBySearch[searchExpression]) {
      handler = setTimeout(() => {
        const readData = query => {
          dispatch({ type: ACTIONS.FETCH_INIT, payload: { searchExpression }});
          return plugin
            .queryEntities(query)
            .then(({ data, nextPageQuery }) => {
              dispatch({
                type: ACTIONS.FETCH_SUCCESS,
                payload: {
                  searchExpression,
                  entities: data,
                  onLoadMore: nextPageQuery ? () => readData(nextPageQuery) : null
                }
              });
            })
            .catch(error => {
              console.error('Error searching entities', error);
              dispatch({
                type: ACTIONS.FETCH_FAILURE,
                payload: {
                  searchExpression,
                  error,
                  onTryAgain: () => readData(query)
                }
              });
            });
        };
        readData({ searchExpression, pageLimit });
      }, delay);
    }
    return () => {
      handler && clearTimeout(handler);
    };
    // Disable as we don't want to refetch when `resultsBySearch` changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plugin, searchExpression, delay]);

  const setSearchExpression = useCallback(searchExpression => {
    dispatch({ type: ACTIONS.SEARCH_CHANGE, payload: searchExpression });
  }, []);

  return {
    entities,
    isLoading,
    error,
    onTryAgain,
    onLoadMore,
    searchExpression,
    setSearchExpression
  };
};
